/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EmailBrandingResponse = {
    primaryColor: string;
    secondaryColor: string;
    buttonStyle: EmailBrandingResponse.buttonStyle;
    showTebutoBranding: boolean;
    logoUrl?: string;
    greeting?: string;
    farewell?: string;
    footerTitle?: string;
    footerAddress?: string;
    footerPhone?: string;
    footerEmail?: string;
    footerWebsite?: string;
};
export namespace EmailBrandingResponse {
    export enum buttonStyle {
        ROUNDED = 'rounded',
        PILL = 'pill',
    }
}

